/** Concatena le classi CSS scartando false, null, undefined e stringhe vuote. */
export function cx(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(" ");
}
